import React, { useState } from 'react';
import { Row, Col } from 'antd';
import { useForm } from 'antd/lib/form/Form';
import { isEmpty, isNil } from 'lodash';
import { useDispatch, useSelector } from 'react-redux';
import { isBeneficiary } from 'utils';
import { SupplierServiceCosts, SupplierServiceInfo } from './components';
import { ApplicationStatusOverview, Button, FormField } from 'components';
import { VoucherErrorBanner } from 'components/layout/components';
import  DownloadedVoucherItems from '../downloadedVoucherItems';
import { serviceDocs } from './serviceDocs';
import VoucherAuditModal from '../voucherAuditModal';

const SupplierServiceForm = () => {
  const dispatch = useDispatch();
  const task = useSelector(state => state.forms.task);
  const [form] = useForm();
  const taskName = useSelector(state => state.forms.task.name);
  const user = useSelector(state => state.user);
  const isViewMode = useSelector(state => state.forms.carrier.viewMode);
  const disableInLoading = useSelector(state => state.forms.disableInLoading);
  const viewMode = isViewMode || !isBeneficiary(user.groups);
  const supplierError = useSelector(state => state.forms?.supplier?.error);
  const voucherInfo = useSelector(state => state.forms?.supplier?.voucherInfo);
  const activeTaskName = useSelector(state => state.forms?.activeTaskName);
  const businessKey = useSelector(state => state.forms?.businessKey);
  const voucherAuditorComment = useSelector(state => state.forms?.supplier?.voucherInfo?.voucher?.voucherAuditorComment);
  const disableVoucherTabs = disableInLoading ||
                             voucherInfo?.responseCode !== "600" ||
                             voucherInfo?.voucher?.status !== "AVAILABLE";
  const [disableAction, setDisableAction] = useState(true);
  const [openAuditRejectModal, setOpenAuditRejectModal] = useState(false);
  const [openApproveAuditModal, setOpenApproveAuditModal] = useState(false);
  const [openApproveBasedOnDocAuditModal, setOpenApproveBasedOnDocAuditModal] = useState(false);

  return (
    <div style={{ maxWidth: '95%', margin: 'auto' }}>
      <VoucherAuditModal 
                error={supplierError}
                openAuditRejectModal={openAuditRejectModal}
                setOpenAuditRejectModal={setOpenAuditRejectModal}
                openApproveAuditModal={openApproveAuditModal}
                setOpenApproveAuditModal={setOpenApproveAuditModal}
                openApproveBasedOnDocAuditModal={openApproveBasedOnDocAuditModal}
                setOpenApproveBasedOnDocAuditModal={setOpenApproveBasedOnDocAuditModal}
              />

        <div style={{display: 'flex', justifyContent: 'space-between'}}>
          <ApplicationStatusOverview id={businessKey} activeTaskName={activeTaskName} style={{display: 'flex',justifyContent: 'flex-start'}}/>
          <div className='modal-buttons-container' style={{display: 'flex',justifyContent: 'flex-end'}}>
            <Button
              type="default"
              id="btn-reject-audit"
              className={"ant-btn-primary reject-btn mt-4_2"}
              label={'Εκκρεμότητα κατόπιν Τυπικού Ελέγχου'}
              disabled={false}
              onClick={() => setOpenAuditRejectModal(true)}
            />
            <Button
              type="default"
              id="btn-approve-audit"
              className={"ant-btn-primary submit-btn mt-4_2"}
              label={'Ώριμη προς έλεγχο'}
              disabled={false}
              onClick={() => setOpenApproveAuditModal(true)}
            />   
            {/* <Button
              type="default"
              id="btn-approve-audit"
              className={"ant-btn-primary submit-btn-v2 mt-4_2"}
              label={'Έγκριση πληρωμής βάσει παραστατικού'}
              disabled={false}
              onClick={() => setOpenApproveBasedOnDocAuditModal(true)}
            />        */}
          </div>  
      </div>

      <span className="mt-2 color-blue-3 text-bold font-size-24">
        Υπηρεσία
      </span>

      <div className='mt-1'>
        <SupplierServiceInfo disableAction={disableAction}/>
      </div>
      
      <div className='mt-4'>
        <SupplierServiceCosts disableVoucherTabs={disableVoucherTabs} setDisableAction={setDisableAction}/>
      </div>

      {!isEmpty(voucherInfo?.voucher?.attachments) &&
        <div className='mt-3'>
          <span className="mt-2 color-blue-3 text-bold font-size-24">
            Έγγραφα
          </span>
          <div className='mt-3'>
            <DownloadedVoucherItems content={serviceDocs()} docs={voucherInfo?.voucher?.attachments} voucherAuditor={true}/>
          </div>
        </div>
      }
       {!isNil(voucherAuditorComment) &&
          <div className='mt-5'>
            <Col className="gutter-row" span={12}>
              <FormField
                label={'Σχόλιο'}
                type='textarea'
                disabled={true}
                rows={12}
                bold={true}
                value={voucherAuditorComment}
              />
            </Col>
          </div>
        }
    </div>
  );
};

export default SupplierServiceForm;
